import React from "react";

import PageHeading from "2g-page-heading";

import { ZdrojeTabs } from "b2b/components/zdroje-tabs/ZdrojeTabs";

// eslint-disable-next-line react/prop-types
const Content = ({ indexActive, data }) => (
  <div>
    <div>index: {indexActive}</div>
    <div>data: {JSON.stringify(data)}</div>
  </div>
);

export function ZdrojeTabsExample() {
  return (
    <>
      <PageHeading>ZdrojeTabs</PageHeading>
      <ZdrojeTabs contentRenderer={Content} />
    </>
  );
}

ZdrojeTabsExample.propTypes = {};

export default React.memo(ZdrojeTabsExample);
